import { render, staticRenderFns } from "./UbigeoSearch.vue?vue&type=template&id=0f3b280c"
import script from "./UbigeoSearch.vue?vue&type=script&lang=js"
export * from "./UbigeoSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports